import { requestConfig, responseConfig } from '@/request/interceptors';
import axios from 'axios';
import { ResponseType } from '@/types';
import { ICE_BASE_API_URL } from '@/request/const';

export const baseInfo = {
  withFullResponse: false,
  baseURL: '/',
  headers: {},
};

// host 规则内则修改接口地址
// const apiDomainProd = ['bnambyh', 'acx-cinemas'];

const getBaseURL = () => {
  let baseURL = process.env.ICE_BASE_API_URL || ICE_BASE_API_URL;
  try {
    // let host = window.location.host.split('.')[1];
    // // 判断 baseURL 是否存在 host
    // if (baseURL.indexOf('host') > -1) {
    //   // host 是否在 apiDomainProd 数组中
    //   if (apiDomainProd.indexOf(host) > -1) {
    //     baseURL = baseURL.replace('host', host);
    //   } else {
    //     baseURL = ICE_BASE_API_URL;
    //   }
    // }
    let apiUrl = baseURL;
    const gopId = window.localStorage.getItem('gop');
    if (gopId) {
      apiUrl = gopId as string;
    }
    return apiUrl;
  } catch (e) {
    return ICE_BASE_API_URL;
  }
};

const instance = axios.create({
  baseURL: getBaseURL(),
});

export const easyRequest = axios.create({});

instance.interceptors.request.use((config) => {
  return requestConfig(config);
});

instance.interceptors.response.use((response) => {
  return responseConfig(response);
});

const request = <T = any>(config): Promise<ResponseType<T>> => {
  return instance(config);
};
/**
 * 自定义请求类型 - 其他的接口返回不同的数据结构 /ed:taobao
 */
export const requestCustomType = <T = any>(config): Promise<T> => {
  return instance(config);
};

export default request;
